// eslint-disable
import i18next from 'i18next';
import Cache from 'i18next-localstorage-cache';
import { config } from '@shakkerai/config';
import { home } from './home';

i18next.use(Cache).init(
  {
    lng: config?.language || 'en', // if you're using a language detector, do not define the lng option
    debug: false,
    resources: {
      en: {
        translation: {
          ...home,
          search_model_placeholder: 'search models',
          search_workflow_placeholder: 'search shortcut app',
          preset_basemodle_type: 'Open 「Advanced Mode」to View more Type',
          preset_basemodle_promode: 'Open 「Advanced Mode」to View more Base Models',
          preset_basemodle_using: 'Using',
          preset_basemodle_update: 'Latest',
          preset_basemodle_desc1: 'Ultimate aesthetics',
          preset_basemodle_desc2: 'Precise prompt responses',
          preset_basemodle_desc3: 'Versatile style',
          preset_basemodle_shakker: 'Shakker Zeno-1',
          model_using: 'Using',
          model_ckp: 'Base Model',
          modelhub_button_Community: 'More community models',
          modelhub_tab_lora_featured: 'Featured',
          Landing_step1_title: 'Community inspirations',
          Landing_step1_content: 'Click to see details of the image on canvas.',
          common_skip: 'Skip',
          Landing_step2_title: 'Remix your image!',
          Landing_step2_content: 'You can make change and remix new images.',
          Landing_step3_title: 'Import your own inspiration',
          Landing_step3_content: 'Click to upload any images.',
          Landing_step4_title: 'Remix',
          Landing_step4_content: 'Automatically generate prompt and match style.',
          Landing_restart_title: 'Restart Guidance Here',
          Landing_restart_content: 'You can restart guidance later. Enjoy your journey of creation.',

          tutorials: 'Tutorials',
          generte_title: 'Generate',
          prompt_placeholder: 'What should we create?',

          prompt_neg_prest: 'Negative Prompt Presets',
          menu_label_preset: 'Presets',
          menu_label_favorite: 'Favorites',
          menu_label_history: 'Recently Used',
          menu_label_hot: 'Popular Selections',
          prompt_negative_placeholder: 'Describing elements not to be included in the image',
          style_title: 'Style',

          model_title: 'Model',
          model_title_checkpoint: 'Base Model',
          model_title_lora: 'Enhanced Model',
          model_window_title_checkpoint: 'Checkpoint',
          model_window_title_lora: 'LoRA',
          model_addlora: 'Add styles/charaters/element models',
          model_added_tip: 'Model Added',
          model_favorite_empty: "You haven't added any models",
          model_search_placeholder: 'Search Models',
          model_search_favorites_only: 'Only my favourite',
          model_search_result_count: '{{count}} models',
          model_base_type_unmatch_tip: 'This kind is unavailable with selected Checkpoint ',
          model_base_type_unmatch_card_tip: 'This kind is unavailable with selected Checkpoint',
          model_sort_option_common: 'Recommended',
          model_sort_option_new: 'New',
          model_sort_option_hot: 'Top',
          model_sort_option_most_used: 'Recently used',
          model_sort_option_fav: 'Newest',

          model_sd15: 'Standard-1.5',
          model_sd15_short: '1.5',
          model_sd21: 'SD 2.1',
          model_sdxl: 'Advanced-XL',
          model_sdxl_short: 'XL',
          model_sd30: 'SD 3.0',
          model_sd35: 'SD 3.5',
          model_sd35_short: 'SD 3.5',
          model_sd35M: '3.5M',
          model_sd35M_short: '3.5M',
          model_flux: 'Superior-Flux',
          model_flux_short: 'Flux',
          model_pony: 'Pony',
          model_pixart_e: 'PixArt Σ',
          model_hunyuan_11: 'Hunyuan 1.1',
          model_hunyuan_12: 'Hunyuan 1.2',
          model_kolors: 'Kolors',
          model_others: 'Others',

          imgref_title: 'Image Reference',
          imgref_inpaint_title: 'Composition Enhance',
          imgref_prompt: 'Prompt',
          imgref_similarity: 'Similarity',
          imgref_composition: 'composition',
          addon_title: 'Face/hand Fix',
          addon_choose: 'Choose an add-on',
          addon_fixface: 'Fix Face',
          addon_fixhand: 'Fix Hand',
          addon_settings: 'Add-ons Settings',
          addon_settings_mergemode: 'Mask merge mode',
          addon_settings_maskedge: 'Mask edge',
          addon_settings_mergemode_none: 'None',
          addon_settings_mergemode_merge: 'Merge',
          addon_settings_mergemode_mt: 'Merge aand Invert',
          setting_imgnum: 'Image Number',
          generate_button: 'Generate',
          generate_button_no_prompt: 'Please prompting your imagine',
          parameter_title: 'Parameters',
          parameter_samplerMethod: 'Sampler',
          parameter_samplingSteps: 'Sampling Steps',
          parameter_seedNumber: 'Seed',
          parameter_drawing: 'Drawing Parameters',
          parameter_steps: 'Sampling Steps',
          parameter_seeds: 'Seeds',
          parameter_scheduler: 'Scheduler',
          parameter_sampler: 'Sampler methods',
          parameter_vae: 'VAE',
          parameter_prompt: 'Prompt Correlation',
          parameter_cfg: 'CFG Scale',
          parameter_clip: 'Clip Skip',
          parameter_vae_auto: 'Automatic',

          inpaint_original_disabled: 'Original model can not be used to inpaint for now',

          reset_generate_params: 'Reset Parameters',
          advanced_mode: 'Advanced',

          imagetool_remix_button: 'Remix',
          imagetool_remix_restore: 'Restore original settings',
          imagetool_changestyle_button: 'Change',
          smartremove_fail_toast_title: 'Fail to remove, please try again later.',
          smartremove_success: 'Removed successfully.',
          smartremove_fail_toast_content: 'Fail to remove, please try again later.',

          share_remix_creator_prefix: 'Created with ',
          share_remix_creator_suffix: '',
          share_remix_simple_mode: 'Simple Mode',
          share_remix_custom_mode: 'Custom Mode',
          share_remix_time_format: 'DD/MM/YY HH:mm',
          share_remix_button: 'Import All Settings to Remix',
          share_remix_params_imported: 'Go create images',
          share_remix_params_imported_tip: 'Settings are all imported to the Generator',

          share_remix_replace_button: 'Replace',
          share_remix_replace_ok_button: 'Got it',
          share_remix_img_replace: "Replace the image you'd like to {{title}}",
          share_remix_img_replace_tip: 'All settings will be imported after uploading',
          share_remix_ref_replace: 'Replace your own images',
          share_remix_ref_replace_tip: 'Create images with your images as reference',

          imagetool_outpaint: 'Outpaint',
          imagetool_outpaint_size: 'Outpaint Size',
          imagetool_outpaint_original_size: 'Original size',
          imagetool_outpaint_new_size: 'Expected size',
          imagetool_outpaint_model_limit: 'Unable to outpaint with SDXL style/models, please use SD 1.5 style/models',
          imagetool_outpaint_size_maxlimit: 'Only images smaller than 1536 x 1536 can be outpainted',
          imagetool_outpaint_size_minlimit: 'Only images larger than 512 x 512 can be outpainted',
          imagetool_outpaint_exetends_minlimit: 'Please adjust the outpaiting area or size',
          imagetool_outpaint_size_adjust: 'Please adjust the outpaiting area or size',

          imagetool_changeFace: 'Face Swapper',
          imagetool_change_face: 'Swap Face',
          imagetool_upload_image: 'Please upload image first',
          imagetool_colorAdjustment: 'Image adjustments',

          img_bottom_tool_inpaint: 'Edit Selection',
          img_bottom_tool_outpaint: 'Expanding Areas',
          img_bottom_tool_collage: 'Colalge',
          img_bottom_tool_original_image: 'Original',
          img_bottom_tool_send_to_canvas: 'Keep',
          img_bottom_tool_view_diff: 'Before/After',

          selection_padding_title: 'Padding',
          selection_padding_tooltips: 'Mask paddings',
          selection_feather_title: 'Feathering',
          selection_feather_tooltips: 'Mask feathering',
          selection_noninvert: 'Inpaint areas which are masked',
          selection_invert: 'Inpaint areas which are not masked',
          inpaint_maskinverted: 'Mask inverted',
          selection_eraser_size_title: 'Eraser Size',
          selection_brush_size_title: 'Brush Size',

          inpaint_style_common: 'General',
          inpaint_style_realistic: 'Realistic',
          inpaint_style_photography: 'Portrait',
          inpaint_style_anime: 'Anime',
          inpaint_style_illustration: 'Illustration',
          inpaint_style_3d: '3D',
          inpaint_style_cg: 'Game/CG',
          inpaint_style_custom: 'Custom',
          inpaint_style_original: 'Original',

          imgref_settings: 'Reference settings',
          cn_options_title: 'Reference',
          cn_basetype_unsupported_tip: 'Feature is not yet available with ({{type}})',
          cn_basetype_unsupported_types: 'Other Dimensions',
          cn_flux_count_limit_tip: 'Only 1 image reference is available  with Flux for now',
          imgref_dimension: 'Reference Dimensions',
          imgref_dimension_in_use: 'It has been used as a reference',
          imgref_dimension_conflict_with_img2img: 'Cannot be used simultaneously',
          cn_method: 'Mode',
          cn_weight: 'Similarity',
          un_support_dimens_tips: 'Available after switching the base model of ({{key}})',
          cn_control_weight: 'Weight',
          cn_control_start_step: 'Starting Step',
          cn_control_end_step: 'Ending Step',
          imgref_upload: 'Choose an image',
          imgref_showoriginal: 'Show original image',

          image_share: 'Share',
          img_link_copied: 'Image Link copied',

          parameter_seeds_random: 'Random',
          parameter_seeds_fixed: 'Fixed',
          style_title: 'Style',
          feed_recommendfeed: 'For you',
          style_selectedtag: 'Selected',
          style_sample: 'More Samples',
          style_using: 'Using',
          style_use: 'Use Style',
          common_fav: 'Favorite',
          style_resource: 'Resource Used',
          style_editor_choice: "Editor's Choice ",
          model_professionalmode: 'professional mode',
          model_modelinfo: 'Details',
          model_unfav_toast: 'Removed from the favorite',
          model_fav_toast: 'Added to the favorite',
          model_modelinfo_title: 'Model Information',
          model_related_images_more: 'Gallery',
          model_related_images: 'Gallery Images({{count}})',
          model_base: 'Base Model',
          model_run_count: 'Run Count',
          parameter_vae: 'VAE',
          model_vae_universal: 'Universal',
          model_recommendckp: 'Checkpoint Suggestions',
          model_recommendlora: 'Lora Suggestions',
          model_trigger: 'Trigger words',
          model_intro: 'Introduction',
          model_filter_base: 'Base Type',
          model_filter_all: 'All Models',
          model_checkpoint: 'CHECKPOINT',
          model_lora: 'LoRA',
          model_lora_limitetoast: 'Only 5 loras can be added at most',
          // model_lora_unavailable_toast: 'Unavailable with ({{name}}） Checkpoint ',
          model_lora_unavailable_toast: 'Incompatible',
          view_all_model_related_images: 'View\nAll',
          model_search_keywords_suggest: 'Suggestion: ',
          model_default: 'Default model',
          imagetool_tilte: 'Image Tools',
          imagetool_remix: 'Remix',
          imagetool_inpaint: 'Inpaint',
          imagetool_inpaint_choose_style_tip: 'Please choose a style before generating',
          imagetool_inpaint_choose_area_tip: 'Please select an area before generating',
          selection_seg: 'Auto segment object',
          selection_lasso: 'Lasso',
          selection_marquee: 'Marquee',
          selection_loading: 'Segmenting objects',
          change_face_loading: 'Segmenting objects...',
          imagetool_inpainting: 'Inpainting',
          imagetool_changefacing: 'Swapping',
          imagetool_outpainting: 'Outpainting',
          imagetool_upscaling: 'Upscaling',
          imagetool_collaging: 'Collaging',
          common_undo: 'Undo',
          common_redo: 'Redo',
          selection_clear: 'Clear Selection',
          magetool_changestyle_button: 'Change',
          common_denoising_strength: 'Strength',
          model_new: 'Choose a checkpoint',
          style_new: 'Choose a style',
          imagetool_upscale: 'Upscale',
          imagetool_upscale_scale: 'Scale',
          imagetool_upscale_size: 'Size',
          imagetool_upscale_params: 'Parameters',
          upscale_tile_type: 'Type',
          upscale_tile_moredetail: 'Enhance',
          upscale_tile_hdr: 'Ultra HD',
          upscale_tile_weight: 'Variability',
          imagetool_upscale_strength: 'Strength',
          imagetool_upscale_details: 'Details',
          imagetool_upscale_hdr: 'HDR',
          imagetool_upscale_similar: 'Similirity',
          imagetool_upscale_prompt: 'Prompt',
          upscale_method: 'Algorithms',
          upscale_td_method: 'Method',
          upscale_strength: 'Creativity',
          imagetool_collage: 'Collage',
          common_denoising: 'Creativity',
          gallary_title: 'Gallary',
          feed_recommendfeed: 'For you',
          common_search: 'Search',
          common_search_result: 'x Results',
          common_search_loading: 'Searching...',
          img_use_style: 'Use Style',
          img_use_style_disabled: 'Not available for uploaded image',
          img_style_sent: 'Style added to the right bar. Go update your prompt',
          img_use_prompt: 'Use Prompt',
          img_use_as_i2i_title: 'Use as image to image',
          img_use_as_i2i_desc: 'Add to bottom bar as Img2img',
          img_use_as_ref_title: 'Use as image reference(Control-Net)',
          img_use_as_ref_desc: 'Add to the right bar as an image reference',
          common_search_noresults: 'No results',
          feed_error: 'Data error, please try again',

          style_lora_title: 'Style Model',

          common_layer_front: 'Bring to front',
          common_layer_back: 'Bring to Back',
          common_download: 'Download',
          common_share: 'Share',
          common_group: 'Group selection',
          common_merge: 'Merge to a new image',
          common_zoom_in: 'Zoom in',
          common_zoom_out: 'Zoom out',
          common_zoom_fit: 'Zoom to fit',
          common_logout: 'Log out',
          common_Guidance: 'Guidance',
          imagetool_removeBackground: 'Remove bg',
          imagetool_selectAreaTool: 'Object Selection',
          imagetool_smartRemove: 'Remover',
          remove_button: 'Remove',
          remove_button_loading: 'Removing',
          extract_button: 'Extract',
          extract_button_loading: 'Extracting',
          generator_pending: 'Launching',
          generator_start: 'Launching...',

          prompt_neg_title: 'Negative Prompt',

          imagetool_upscale_upperlimit: 'Upscale supports up to 5120 x 5120',
          imagetool_upscale_minimum: 'Upscale supports a minimum of 256x256 image',
          imagetool_extractpara: 'Generate parameters',

          imagetool_param_extracting: 'Generating parameters...',
          imagetool_param_rextract: 'Re-generate parameters',
          imagetool_param_size: 'Size',

          controlnet_fail_toast_title: 'Fail to extract the composition of the image.',
          controlnet_fail_toast_content:
            'To set the composition as reference, please re-extract it by clicking on the composition reference module.',

          common_use: 'Use',
          model_use: 'Use model',
          model_use_short: 'Use',
          model_used_short: 'Used',
          model_unuse: 'Stop using',
          style_default: 'Default Style',

          common_collect: 'Collect',
          common_download: 'Download',
          common_delete: 'Delete',
          history_exitselection: 'Exit Selection',
          history_selected: 'selected',
          history_selectall: 'Select All',
          history_unselectall: 'Unselect',
          common_uncollect: 'Uncollect',
          imgref_composition: 'Composition',
          history_allimageref: 'Set as Reference',

          // 以上内容是2024年02月22日新增
          shortcut_title: 'Shortcut',
          shortcut_zoom_title: 'Zoom in / Zoom out Canvas',
          shortcut_pan_title: 'Move Canvas',
          shortcut_other_title: 'Others',
          shortcut_hold: 'Hold down',
          shortcut_scrollmoues: 'Scroll',
          shortcut_drag: 'Drag',
          shortcut_drag_2: 'Drag',
          shortcut_keyboard: 'Keyboard',
          shortcut_trackpad: 'Trackpad',
          shortcut_mouse: 'Mouse',
          shortcut_remove: 'Remove images',
          shortcut_undo: 'Undo',
          shortcut_redo: 'Redo',
          shortcut_locate: 'Locate',
          clean_title: 'Clear out images on the Canvas',
          clean_content1: 'There are',
          clean_content2: 'images on your canvas,which may slow down the canvas;',
          clean_content3: 'you can still access them in the',
          clean_content4: 'after clearing.',
          clean_button: 'Clear out all images',
          clean_doublecheck_title: 'Clear all images from the canvas？',
          clean_doublecheck_content: ' You can still access them in the History after clearing.',

          key: 'hello world',
          'global.server.error': 'Server error',
          common_more_actions: 'More Actions',
          history_album_selected: 'Selected Album',
          page_load_error: 'Oops...Something went wrong',
          try_again: 'Please try again.',
          tool_move: 'Move',
          tool_rectangle: 'Rectangle(R)',
          tool_ellipse: 'Ellipse(O)',
          tool_triangle: 'Triangle',
          tool_hand: 'Hand tool',
          tool_upload: 'Upload image(N)',
          canvas_zoomin: 'Zoom In',
          canvas_zoomout: 'Zoom Out',
          canvas_zoomreset: 'Reset',
          canvas_locate_generator: 'Locate to Generator',
          locate: 'Locate',
          color: 'Color',
          background_color: 'Background Color',
          user_login: 'Login',
          user_logout: 'Logout',
          clear_forzen_task: 'Clear frozen tasks',
          canvas_zoomfit: 'Fit',
          generator: 'Generator',
          layer: 'Layer',
          image: ' image',
          inpaint: 'inpaint',
          inpaint_limit: 'Up to {{n}} partial inpaints can be created simultaneously',
          upscale_max_tips: 'Maximum size is less than {{value}}',
          page: 'Page',
          group: 'Group selection',
          mixed: 'Mixed',
          flattenImage: 'Flatten image',
          rect: 'Rectangle',
          ellipse: 'Ellipse',
          triangle: 'Triangle',
          selection: 'Selection Area',
          create_selection_area: 'Create Selection Area',
          gallery: 'Gallery',
          style: 'Style',
          details: 'Details',
          style_suggestion: 'Style recommendation based on suggested words',
          prompt: 'Prompt',
          prompt_suggestion: 'Suggestions',
          generate: 'Generate',
          prompt_negative: 'Negative Prompt',
          prompt_negative_placeholder: 'Describe what you want to exclude in your image',
          prompt_negative_standard: 'Standard',
          prompt_negative_Anime: 'Anime and Manga',
          prompt_negative_hands: 'Botched hands',
          prompt_negative_style: 'Artistic style',
          upscale_style_1: 'Realistic portrait',
          prompt_suggestion_title: 'Prompt suggestions',
          style_search_placeholder: 'search',
          cancel: 'Cancel',
          confirm: 'Confirm',
          history: 'History',
          more: 'More',
          clearall: 'Clear All',
          done: 'Done',
          apply: 'Apply',
          match_style: 'Match Style',
          match_model: 'Match Model',
          match_reference: 'Reference Image',
          style_history: 'Recently used',
          style_use: 'Apply',
          style_disable: 'Disable',
          search_suffix: 'Styles',
          search_suffix2: 'results',
          style_using: 'Using',
          style_suggestion_title: 'Similar Style',
          style_info_model: 'Quoting model',
          style_info_parameter: 'Parameter information',
          suggestion_base_model_title: 'Base Model Suggestion',
          newly_favorited_appy_tip: 'Model added to your favorites, try it',
          follower: 'Followers',
          style_suggestion_noresults: 'No matching styles found',
          style_history_noresults: 'No history data',
          gallery_noresults: 'No Results',
          gallery_match_models: 'Match Models',
          gallery_send_to_canvas: 'Send to canvas',
          gallery_generation_info: 'Generation Info',
          style_suggestion_false: 'Style matching failed, please retry',
          style_suggestion_bottom: 'End of content',
          Styles_for_you_based_on_your_prompt: 'Styles for you based on your prompt',
          For_You: 'For You',
          preparing_for_you: 'preparing for you',
          generator_size: 'Image Size',
          generator_size_custom: 'Custom',
          generator_parameter: 'Parameter Settings',
          generator_highres: 'High Resolution',
          generator_imgnum: 'Number of Images',
          generator_allparameter: 'Advanced Parameters',
          generator_locate: 'Locate to un-photoshopped image canvas',
          network_error: 'Network Error',
          controlnet_preprocess_network_error: 'Network Error',
          generation_info: 'Generation Info',
          canvasimg_outside: 'Uploaded Image',
          characteristcs_title: 'Composition',
          characteristcs_applysize: 'Applying Dimensions to the Generated Canvas',
          uploading: 'Uploading...',
          upload_tip: 'Drag & Drop Image Here',
          fresh_upload_tip: 'Upload reference image',
          replace: 'Replace',
          duplicate: 'Duplicate',
          reference: 'Reference',
          ImageReference: 'Reference',
          lock_ratio: 'Constrain proportions',
          menu_restore_original_image: 'Restore to Original Image',
          menu_group: 'Group Selection',
          menu_apply_reference: 'Send to image reference',
          menu_save_to_canvas: 'Save to Canvas',
          menu_ungroup: 'Ungroup',
          menu_locate: 'Locate',
          menu_download: 'Download',
          menu_copy: 'Copy',
          menu_image_send_params: 'Send generation info to the Generator',
          menu_merge: 'Merge To A New Image',
          menu_delete: 'Delete',
          menu_bring_front: 'Bring to front',
          menu_send_back: 'Send to back',
          menu_clear_generation: 'Clear Generation Result',
          characteristcs_preset_title: 'Reference Mode',
          characteristcs_preset1: 'Loose',
          characteristcs_preset2: 'Detailed',
          characteristcs_allsettings: 'Advanced Settings',
          characteristcs_generalscale: 'Overall Reference Scale',
          characteristc: 'Composition',
          characteristcs: 'Characteristcs',

          image_author: 'Created by',
          send_to_generator: 'Send to Generator',
          generate_prams_sent_tip: 'All Set',

          cn_resize_mode: 'Resize',
          cn_resize_mode_stretch: 'Stretch',
          cn_resize_mode_crop: 'Crop',
          cn_resize_mode_fill: 'Fill',

          cn_face_upload_image: 'Upload Image',

          cn_face: 'Character',
          cn_face_img1: 'Face',
          cn_face_img2: 'Facial Pose & Shots',
          cn_face_ref_preset: 'Preset',
          cn_face_ref_same: 'Use Face Image',
          cn_face_ref_custom: 'Custom',
          cn_face_ref_front: 'Front',
          cn_face_ref_right: 'Right',
          cn_face_ref_left: 'Left',
          cn_face_ref_halfbody: 'Half',
          cn_face_ref_fullbody: '3/4 shot',
          cn_face_ref_portrait: 'Headshot',

          cn_face_img2_send: 'Send to img2img',
          cn_face_img1_tips: 'Face are clearly visible',
          cn_face_upload_image: 'Upload image',

          cn_face_title: 'Face Image',

          cn_all_params: 'Advanced settings',
          cn_source_referece_only_tip: 'Only the selected image can be used as the reference',

          imgref_characteristcs_preference: 'Control mode',
          cn_control_mode_1: 'Prioritize prompt',
          cn_control_mode_2: 'Balance',
          cn_control_mode_3: 'Prioritize reference',

          cn_model: 'Model',
          cn_preprocessor: 'Preprocessor',
          cn_pixel_perfect: 'Pixel Perfect',
          cn_pixel_perfect_on: 'On',
          cn_pixel_perfect_off: 'Off',
          cn_preprocessor_resolution: 'Resolution',
          cn_disabled_for_current_model: 'Not available when using current model',
          apply_reference_size: 'Apply dimentions to generator',
          loading: 'Loading',
          characteristcs_canny: 'Canny',
          paremeter: 'Basic Parameters',
          parameter_sampling_steps: 'Sampling Steps',
          parameter_vae: 'VAE',
          parameter_cfg: 'CFG Scale',
          parameter_clip: 'Clip Skip',
          parameter_seeds_random: 'Random',
          parameter_seeds_fixed: 'Fixed',
          parameter_seeds_placeholder: 'Input seed number',
          merge: 'Merge Layers',
          original: 'Original',
          originalimage: 'Original image',
          inpaint_scale: 'Creativity',
          image_merge_error: 'Fail to merge layers',
          image_merge_success: 'Layers Merged Successfully',
          image_merge_result_too_large: 'The size of the merged image is too large',
          image_segment_error: 'Fail to segment this image.',
          image_segment_error_sub: 'Please try other images or retry later.',
          image_segment_success: 'Image Segmented Successfully',
          image_segment_empty: 'The segmentation result is empty',
          image_crop_error: 'Fail to to crop image',
          image_crop_success: 'Image Cropped Successfully',
          image_cropping: 'Image Cropping',
          image_merging: 'Image merging',
          image_cutting: 'Removing Background',
          image_cutout_error: 'Fail to remove the background.',
          image_cutout_error_sub: 'Please try other images or retry later.',
          image_cutout_success: 'Image background removed successfully',
          image_cutout_tip: 'Remove background',
          imagetool_crop: 'Crop',
          image_segment_tip: 'Auto segment object',
          image_lasso_tip: 'Lasso',
          image_rect_tip: 'Marquee',
          image_tool_exit: 'Exit',
          image_tool_new_image: 'New Image',
          image_tool_new_image_upload: 'Upload',
          image_tool_new_image_uploading: 'Uploading',
          image_tool_unselect_tip: 'Select or upload an image to activate ',
          image_tool_collage_unselect_tip: 'Select at least 2 images on canvas to activate',
          image_tool_select_button: 'Select an image',
          image_tool_reference: 'Reference',

          image_publish_entry_btn: 'Publish to Shakker',
          image_publish_title: 'Share your image with generation info',
          image_publish_img_title: 'Image Title',
          image_publish_img_tags: 'Image Tags',
          image_publish_img_desc: 'Image Description',
          image_publish_success: 'Published',
          image_publish_fail: 'Fail to publish',
          image_publish_btn: 'Publish',

          image_extract_success: 'extract success',
          image_extract_fail: 'extract fail',

          image_tool_adjust: 'Vary',
          image_tool_vary_overall: 'Strong',
          image_tool_vary_overall_tip: 'Makes broader changes to the image.',
          image_tool_vary_details: 'Subtle',
          image_tool_vary_details_tip: 'Make images similar to this one.',

          image_tool_use: 'Use',
          image_tool_use_style: 'Style',
          image_tool_use_style_tip: 'Generate images based on related style',
          image_tool_use_style_disabled_tip: 'Not available for uploaded image',
          image_tool_use_lora: 'Style',
          image_tool_use_lora_disabled_tip: "This image doesn't use the enhanced model.",
          image_tool_use_prompt: 'Prompt',
          image_tool_use_image: 'Image',

          image_info_weight: 'Weight ',
          image_info_reproduce_inpaint: 'Reinpaint',
          image_info_reproduce: 'Edit',

          workflow_image_upload: 'Upload Image',
          workflow_video_upload: 'Upload Video',
          workflow_video_replace: 'Replace Video',
          workflow_video_play: 'Play Video',
          workflow_model_loading: 'Model Loading',
          workflow_model_picker: 'Pick a model',
          workflow_mask_source_image_tip: 'Please select an image to use as the mask',
          workflow_mask_draw_button: 'Draw mask',
          workflow_image_segmenting: 'Segmenting',

          inpaint_discard: 'Discard',
          controlnet_reload: 'Reload',
          controlnet_preprocess_error: 'Fail to extract the composition of the image.',
          controlnet_preprocess_error_sub:
            'To set the composition as reference, please re-extract it by clicking on the composition reference module.',
          error_controlnet_image_loading: 'Please wait for the image composition to be extract',
          generator_failed: 'Generation failed. Fast tokens and other benefits deducted have been returned.',
          generator_success: 'Image Generated Successfully',
          generator_queue: 'In Queue... Position {{n}}',
          generator_failed_2: 'Creation Failed,',
          generator_regenerate: 'Re-generate',
          generator_rerun: 'Re-run',
          generator_exitrun: 'Exit-run',
          generator_task_waiting: 'Waiting',
          generator_task_queuing: 'Queuing',
          generator_loading: 'Loading Resources...',
          generator_ing: 'Generating Images... {{n}}%',
          generator_limit: 'We can process 3 tasks at a time. Please wait until current ones finish',
          history_entrance: 'History',
          history_tab1: 'All',
          flow_empty_tip1: 'No Shortcut Apps have been used yet.',
          flow_empty_tip2: 'Recently Used',
          history_tab2: 'Album',
          search_clear: 'Cancel',
          history_search_placeholder: 'Search',
          history_search_placeholder_gallery: 'Search',
          history_searching: 'Loading',
          history_rank_up: 'Oldest to Latest',
          history_rank_down: 'Latest to Oldest',
          storage: 'Storage used',
          history_limit: 'images',
          history_useup1: 'The storage space is running out.',
          history_useup2: 'It is recommended to proactively delete unnecessary images to free up storage space.',
          history_morestorage: 'Get more storage',
          collect: 'Collect',
          download: 'Download',
          delete: 'Delete',
          copy_image: 'Copy Image',
          history_regenerate: 'Import all the parameters',
          history_ref: 'Send to image reference',
          history_movetocanva: 'Send to Canvas',
          model_fetch_error: 'Failed to get model information',
          copy_prompt: 'Copy Prompt',
          prompt_fetch_error: 'Failed to get prompt',
          prompt_fetch_empty: 'No valid content obtained',
          prompt_copy_toast: 'Prompt is copied',
          history_deletecheck_main: 'Confirm to delete the n images selected?',
          history_deletesingleimage: 'Confirm to delete?',
          history_deletecheck_sub: 'Images cannot be recovered after deletion.',
          history_bottom: 'You’ve reached the bottom of the list',
          history_album_add: 'Add to my album',
          history_album_new: 'New Album',
          history_album_ungrouped: 'Ungrouped',
          history_album_imgcoount: 'n images',
          history_album_change: 'Change',
          rename: 'Rename',
          history_album_deletecheck_main: 'Confirm to delete the album "xxx"?',
          history_album_deletecheck_sub: 'Delete the pictures in the album as well.',
          history_album_delallcheck_main: 'Confirm to delete all the images in "Ungrouped"?',
          history_album_placeholder: 'There is no image in this album.',
          history_album_defualtname: 'New Album',
          create: 'Create',
          history_image_info: 'Image Info',
          history_usemodel: 'Model',
          professionalMode: 'Professional Mode',
          model: 'Model',
          allsettings: 'Advanced Settings',
          copy: 'Copy',
          collapse: 'Collapse',
          expand: 'Expand',
          img_scale: 'Scale',
          parameter_seed: 'Seeds',
          parameter_applyall: 'Import all the parameters',
          nsfw: 'NSFW Content',
          nsfw_view: 'View',
          illigal_content: 'Illegal Content',
          share: 'Share With Link',
          copied: 'Copied',
          collect_toast: 'Added to ',
          history_album_addtoast: 'Collected to "专辑名称',
          collect_cancel_toast: 'Unfavorited',
          history_album_delete_toast: 'Album "xxx" is removed',
          history_ref_toast: 'Set as composition reference image successfully',
          history_apply_toast: 'All the parameters are imported',
          copy_prompt_toast: 'Prompt is copied',
          copy_image_toast: 'Image is copied',
          copy_image_error_toast: 'Fail to copy the image',
          copy_negprompt_toast: 'Negative prompt is copied',
          delete_img_toast: 'The image is deleted',
          delete_imgs_toast: 'N images are deleted',
          download_limit_toast: 'Up to x images can be downloaded each time',
          style_use_toast: 'The selected style has been applied',
          style_pulloff_toast:
            'This style has been removed by the original author and is temporarily unavailable. Please use other style.',
          parameters_import_failed: 'Fail to import the parameters since this image has been removed.',
          share_success_toast: 'Link is copied',
          upload_fail_toast: 'Image upload failed. Please try to re-upload the file.',
          upload_all_fail_toast: 'All images failed to upload.',
          upload_completed_toast: 'Image uploaded successfully. {{errorCount}} images failed to upload.',
          upload_success_toast: 'Image uploaded successfully',
          internet_loading_toast: 'Poor network connection. Loading resources slowly. Please wait...',
          internet_suggestion_toast: 'Poor network connection, Please switch to a better network environment',
          internet_fail_toast: 'Network connection failed, Please check your internet connection',
          internet_back_toast: 'Network Connection Restored',
          generator_timeout_toast: 'Image generation task timed out, Please retry',
          model_pulloffissue_toast: 'Failed to load the resource. Please try to use other styles.',
          img_format_toast: 'Incorrect file format. Please upload PNG, JPEG, or JPG format images',
          img_size_toast: 'Please Upload Image Below 20MB',
          img_resolution_toast: 'The image resolution is too large. Please upload images below 2048 * 2048',
          inpaint_resolution_toast:
            'The image resolution is too large, Please adjust the image size to lower than 2048*2048',
          img_resize_toast: 'Image is resized automatically due to its large scale',
          generator_resize_toast: 'Generator is resized automatically',
          inpaint_size_too_large:
            'The size of the generated image is too large, Please adjust the image size to lower than 2048*2048',
          generator_multitast_toast:
            'You currently have an image being generated, Please initiate next image generation after its completion',
          user_feedback_toast: 'Please Describe the Issue you Encountered, We Will Contact You Later via Email',
          user_inputemail: 'Please enter your email address',
          generator_nostyle_toast: 'Generate images only after selecting a style',
          generator_queue_overtime: 'Queue timeout. Please retry later',
          generator_fail_toast: 'Image generation failed, Please retry later',
          loading: 'Loading',
          segmantanything: 'segmantanything',
          history_storagefull: 'Storage is full.',
          history_storagefullalert: 'Please delete unnecessary images to free up storage space.',
          history_storagefull_tip:
            'Please go to "Generation History" to delete unnecessary images to free up storage space.',
          comfirm: 'Comfirm',
          no_search_result_all: 'No images were found.',
          no_search_result_album: 'No images were found.',
          no_history_record: 'There is no generation record yet.',

          imgref_noselece: 'Select mode',
          imgref_limit: 'You can only add up to {{value}} image references.',

          img_no_switch_tip_title: 'Replacing the image is not advised',
          img_no_switch_tip_message: 'For optimal results, use the same image as a img2img',

          illigal_content_text:
            'This image involves inappropriate content (excessively violent, horrific, etc.). Please refrain from generating such images.',
          toolbar_disabletooltips_oneimage: 'Select or upload an image to activate',
          toolbar_disabletooltips_twiimage: 'Select at least 2 images to activate.',
          simple_tip_text: '仅自定义模式下可使用',
          pro_mode_opentip: 'Switch to Custom Mode to use it',
          setting_text: 'Setting',
          prompt_setting_autofill: 'Autofill',
          recommend_expand: 'Prompt Suggestions',
          two_language: '双语对照',
          prompt_setting_enhance: 'Enhance',
          prompt_setting_title: 'Prompt Settings',
          guidance_switch_button: 'Switch',
          guidance_custommodel_title: 'Customize Your Model',
          guidance_custommodel_content: 'Switch to Custom Mode for more model options',
          guidance_imgref_title: 'More dimensions & Advanced settings',
          guidance_imgref_content: 'Switch to Custom Mode for more image reference settings',
          imagetool_changestyle: 'Restyle',
          simeplemode_base_tool_tip: 'Switch to Custom Mode to match models',
          simplemode_landing_step1: 'Which best describes you?',
          simplemode_landing_case1: 'graphic designer',
          simplemode_landing_case2: 'Game Designer',
          simplemode_landing_case3: 'photographer',
          simplemode_landing_case4: 'Space Designer',
          simplemode_landing_case5: 'Illustrator',
          simplemode_landing_case6: 'AI Enthusiast',
          simplemode_landing_step2: 'Pick Your Mode',
          simplemode_simplemode: 'Beginner Mode',
          simplemode_simplemode_info: 'Best for AI image generation newbies',
          simplemode_custommode: 'Custom Mode',
          simplemode_custommode_info: 'Best for experienced SD users',
          common_last: 'Go Back',
          common_next: 'Next',
          simplemode_landing_endbutton: 'Launch',
          prompt_placeholder_recreate: 'Describe what you want to re-create',
          simplemode_prompt_placeholder: 'What should we create?',
          prompt_suggestion_text: 'Suggestion',
          toolbar_switch: 'Switch to Custom Mode to activate',
          topbar_multiselect: 'Multiple images are selected, but this feature only supports one image.',
          guidance_custommode_title: 'Switch to Custom Mode',
          guidance_custommode_content: 'Switch between Beginner and Custom modes.',
          guidance_got_button: 'Got it',
          imgref_similarity_more: 'More dimensions & Advanced settings',
          imgref_switchcus: 'Switch to Custom Mode to use multiple reference',
          // add 096
          imgref_mode_tile: 'Tile',
          imgref_mode_referenceonly: 'Reference Only',
          imgref_mode_canny: 'Edge',
          imgref_mode_MLSD: 'MLSD Edge',
          imgref_mode_lineart: 'Lineart Edge',
          imgref_mode_soft: 'Soft Edge',
          imgref_mode_scribble: 'Scribble Edge',
          imgref_mode_depth: 'Depth',
          imgref_mode_seg: 'Segmentation',
          imgref_mode_normal: 'Normal map',
          imgref_mode_openpose: 'Pose',
          imgref_mode_color: 'T2IA',
          imgref_mode_shuffle: 'Shuffle',
          imgref_mode_recolor: 'Recolor',
          imgref_mode_ip_adapter: 'IP-Adapter',
          imgref_mode_entity_control: 'Subject',
          imgref_mode_brightness: 'Brightness',
          use_model: 'Try it',
          simplemode_sd3_tag: 'Newest',
          simplemode_model_photo: 'Photorealism',
          simplemode_model_art: 'Illustration',
          simplemode_model_3D: '3D',
          simplemode_model_CG: 'CG',
          simplemode_model_Anime: 'Anime',
          simplemode_model_Architecture: 'Architecture',
          simplemode_model_base: 'SDXL',
          simplemode_model_more: 'Customize Models',
          simplemode_style: 'Style',
          simplemode_style_unavailiable: 'Using this style with the chosen model might generate poor results',
          common_sort1: 'Recommended',
          common_sort2: 'New',
          common_sort3: 'Top',
          gallary_sample_more: 'You might like',
          gallary_home: 'Homepage',
          gallary_sample_title: 'samples',
          model_fromgallary: 'Model Combo',
          upscale_para_1: 'Creativity',
          upscale_para_2: 'Style',
          upscale_style_2: 'Anime',
          upscale_style_3: 'CG',
          upscale_style_4: 'Illustration',
          upscale_style_5: '3D',
          feature_disabled_for_sd3: 'Not available for now when using {{type}}',
          feature_disabled_for_sd3_2: 'Not available for now when using {{type}}',
          character_custom_title: 'LoRA Recommendation',
          character_beginner_title: 'Characters',
          share_image_title: 'Share your image with generation info',
          share_image_content_prefix:
            'I created stunning images with Shakker AI Generator, Check my workflow and settings.',
          share_image_link_title: 'Copy Link',
          share_image_all_title: 'Copy All',
          setting_size: 'Image Size',
          original_setting_size: 'Original Image Size',
          imgupload_placeholder: 'Upload an image or send an image from canvas',
          imgupload_placeholder_entity_control: 'Upload an image with a single clearly visible subject',
          prompt_imgtoimg: 'img2img',
          img2img_use_as_reference: 'Use as Image Reference',
          img2img_disabled_flux1: 'Not available for now when using FLUX.1',
          img_prompt: 'Generate Prompt',
          img_size: 'Match size',
          prompt_imgtoimg_tips: 'Upload an image to start image to image',
          prompt_setting_enhance_on: 'Prompt improvement is on',
          prompt_setting_enhance_off: 'Prompt improvement is off',
          hires_original: 'Original Size',
          hires_scale: 'Scale',
          hires_algorithm: 'Algorithm',
          hires_step: 'Steps',
          hires_finalimage: 'Image Size',
          setting_hires: 'Hires Fix',
          imgref_similarity_original: 'Vary Subtle',
          imgref_similarity_creative: 'More Creative',
          imgref_similarity_cus: 'Customize',
          canvas_rate: 'Rate',
          rate_thanks: 'Thanks for your feedback!',
          rate_title: 'Feedback',
          common_cancel: 'Cancel',
          common_submit: 'Submit',
          rate_op1: 'Results not relevant to prompts',
          rate_op2: 'Unexpected style',
          rate_op3: 'Slow image generation',
          rate_op4: 'Poor Qualiy',
          rate_op5: 'Poor aesthetic',
          rate_op6: 'Others',
          rate_describe: 'Add a note (Optional)',
          rate_question: 'What went wrong?(required)',
          prompt_weight: 'Weight',
          imgref_advancetips_title: 'Swith to Advanced Mode to access',
          imgref_advancetips_content: 'Adjust all Control-net settings in Advanced Mode',
          basemodel_preset: 'Preset Models',
          basemodel_all: 'All base models',
          basemodel_toshakker1: 'No models in your favorite',
          basemodel_toshakker2: 'explore and add models to your favorite ',
          basemodel_toshakker3: 'Model Hub',
          lora_details_presetpara: 'Preset Params',
          style_history_new: 'History',
          models_favorites: 'Favorites',
          imagetool_inpiant_style: 'Style',
          lora_recommend: 'Enhanced Model (LoRA) Suggestion',
          model_promptbase: 'Might fit your prompt',
          common_sort4: 'All Type',
          model_nohistory: 'No usage history.',
          model_nosearch: 'No search results.',
          model_nofav: 'No models have been favorited, go favorite some from all models!',
          model_search: 'Search Result',
          model_search_text: 'Search',
          model_result_no_more: 'No more models',
          model_search_selected: 'Types',
          basemodel_largest_match: 'Most Used with Base Model',
          model_online_unsupported: 'Not availiable for now.',
          model_recently_favorite: 'Last Added',

          image_card_info: 'Info',
          gallery_title: 'Image Showcase',
          gallery_no_more: 'No more pictures',
          model_gallery_title: 'Model Gallery',
          model_gallery_tab_cases: 'Samples',
          Modelgallery_title_Example: 'Example',
          Modelgallery_title_Gallery: 'Gallery',
          imakgegallery_title_rec: 'Recommend',
          Modelgallery_title_top: 'Top',
          model_gallery_tab_more: 'Top',
          model_gallery_btn: 'Gallery',
          model_gallery_latest_version: 'Latest',
          model_gallery_version_all: 'All Versions',

          imgref_repreview: 'Re-generate',
          imgref_preview: 'Preview',
          lora_details_title: 'LoRA Details',
          lora_details_title2: 'Base Model Suggestion',
          prompt_tip_text: 'Describe your imagination',
          prompt_tip_content: 'Input basic prompts, we will improve it automatically for better results',
          tip_change_browser_1: 'Your current browser has compatibility issues. Please switch to',
          tip_change_browser_2: 'Chrome for uninterrupted access.',
          tip_update_browser_version_text:
            'Your current browser version is outdated. Please upgrade to the latest version.',
          guideTip_prompt_title: 'Start Here with Prompt',
          guideTip_prompt_desc:
            'Enter your style and main subject prompts to craft stunning images. Once you\'ve got your ideas ready, hit "Generate" and let the magic happen.',
          guideTip_checkpoint_title: 'Base Model',
          guideTip_checkpoint_desc:
            'Using the Shakker Default Model, you can draw any images you imagine, with a hundred styles including realistic photography, illustrations, anime, 3D, etc.',
          guideTip_lora_title: 'Enhanced Models',
          guideTip_lora_desc: 'Use Enhanced models to enhance specific styles, characters, elements, object and more.',
          guideTip_img2img_title: 'Image to Image',
          guideTip_img2img_desc: 'Use img2img to reference the general style or content of an image.',
          guideTip_imgreferrer_title: 'Image Reference',
          guideTip_mode_title: 'Advanced Mode',
          guideTip_mode_desc:
            'Stable Diffusion Player? Unlock advanced features by opening the Advanced Mode. This allows you to choose from thousands of Checkpoint/LoRA models, customize parameters, utilize the full Control-net, set Hire-fix, and use ADetailer and other SD functionalities.',
          guideTip_imgreferrer_desc:
            'Use Image Reference to achieve consistent characters, reference Depth, Lineart, Pose, and more.',
          guideTip_finish_title: 'Intro Guide',
          guideTip_finish_desc_1: 'You can check this guide at anytime by clicking this',
          guideTip_finish_desc_2: 'icon',
          prompt_guide_topic: 'Try prompts:',
          prompt_guide_switch: 'Refresh',
          prompt_guide_close_title: 'Turn off Starter Suggestions？',
          prompt_guide_stop: 'Turn off',
          prompt_guide_close_once: 'Just This Time',
          history_title: 'Generation History',
          history_bydateimg: 'images',
          tip_next: 'Next',
          tip_prev: 'Previous',
          tip_done: 'Finish',
          load_more: 'Load More',
          set_neg_prompt_tip: 'Negative prompt',
          set_neg_prompt_disabled_tip: 'Only avaliable when using SD1.5 base model',
          add_text: 'Add',
          prompt_weight_button: 'Add Weight',
          prompt_weight_title: 'Add Weight',
          prompt_improve_button: 'Improve Prompt',
          prompt_delete_button: 'Delete all prompt',
          prompt_weight_placeholder: 'Describe the content you want to focus on creating.',
          prompt_weight_title: 'Add Prompt Weight',
          prompt_improved: 'Improved prompt',
          public_tips_desc:
            "Generated images are shared publicly by default. They're added to the gallery to improve the model. To keep them private, adjust your settings in History.",
          prompt_neg_setting_title: 'Negative Prompt',
          modelhub_tab_featured: 'Featured',
          modelhub_tab_more: 'See all',
          public_setting: 'Public Images',
          public_tips_title: 'Public & Private Images',
          color_title: 'Color Palette',
          upload_image_to_get_colors: 'Upload image to get colors',
          color_para_title1: 'Custom',
          color_para_title2: 'Preset',
          randomize: 'Randomize',
          color_para_para1: 'Strength',
          color_upload_para1: 'Extract color from image',
          color_upload_para2: 'Upload images / Drag images from canvas',
          color_para_title3: 'Color Picker',
          color_canvas_para1: 'Use as color palette',
          color_canvas_para2: 'Add to the right bar as color palette',
          color_upload_all: 'Apply',
          pen_size: 'Size',
          common_finish: 'Done',
          tool_r: 'Rectangle',
          tool_o: 'Ellipse',
          tool_P: 'Pen',
          r_size: 'Custom',
          img_to_text: 'Img2Text',
          imgadjust_title: 'Image adjustments',
          imgadjust_sutitle1: 'AI Adjustments',
          imgadjust_upload: 'Upload an image to match its colors',
          imgadjust_upbutton: 'Upload',
          imgadjust_sutitle2: 'Adjustments',
          imgadjust_para1: 'Hue',
          imgadjust_para2: 'Saturation',
          imgadjust_para3: 'Exposure',
          imgadjust_para4: 'Contrast',
          imgadjust_para5: 'Opacity',
          tool_text: 'Text',
          tool_t_placeholer: 'Input your text',
          flow_g_title: 'Generator',
          flow_g_flow: 'Workflow',
          outpaint_over_size_tips:
            'Using this ratio will result in a length or width greater than 2048, exceeding the range.',
          flow_edit: 'Editing...',
          flow_runing: 'Running...',
          flow_g_op1: 'Rename',
          flow_g_op2: 'Download',
          flow_g_op3: 'Delete',
          flow_g_op4: 'Duplicate',
          flow_g_op5: 'Run',
          selection_auto: 'Auto',
          selection_text1: 'Subject',
          selection_text2: 'Face',
          selection_text3: 'Skin',
          selection_text4: 'Hair',
          selection_text5: 'Custome',
          img_bottom_bar_edit: 'Edit',
          img_bottom_bar_use: 'Use as',
          inpaint_edit_community: 'Community',
          comfy_loading: 'Loading',
          speed_up: 'Speed-up',
          gprogress1: 'Generating...',
          gprogress2: 'Inpainting...',
          gprogress3: 'Upscaling...',
          gprogress4: 'Outpainting...',
          flow_g_apply: 'Shortcut App',
          flow_quick_apply: 'Shortcut App',
          flow_quick_apply_icon: 'Shortcut App',
          style_code: 'Style seed',
          copy_success_message: 'Copy success',
          copy_fail_message: 'Copy failure',
          press_esc_exit: 'Press Esc to exit',
          use_btn: 'Run',
          use_btn1: 'Run',
          back_projects: 'Back to Projects',
        },
      },
      zh: {
        translation: {
          ...home,
          search_model_placeholder: '搜索全站海量模型',
          search_workflow_placeholder: '搜索全站AI工具',
          preset_basemodle_type: '开启高级模式，查看更多类型',
          preset_basemodle_promode: '开启高级模式，查看更多基础模型',
          preset_basemodle_using: '使用中',
          preset_basemodle_update: '最新',
          preset_basemodle_desc1: '真懂美，不再一眼AI',
          preset_basemodle_desc2: '见识广，反应快，概念精准响应',
          preset_basemodle_desc3: '风格全面，适合各种行业场景',
          preset_basemodle_shakker: '星流 Star-3 Alpha',
          model_using: '使用中',
          model_ckp: '基础模型',
          modelhub_button_Community: '更多社区模型',
          modelhub_tab_lora_featured: '精选',
          Landing_step1_title: '从社区图片寻找灵感',
          Landing_step1_content: '点击图片，在画布上查看图片生成信息',
          common_skip: '跳过',
          Landing_step2_title: '图片衍生',
          Landing_step2_content: '调整参数，衍生出相似图片',
          Landing_step3_title: '上传自己的灵感图',
          Landing_step3_content: '点击上传任意图片',
          Landing_step4_title: '图片衍生',
          Landing_step4_content: '自动反推提示词，并匹配风格',
          Landing_restart_title: '重看新手引导',
          Landing_restart_content: '你可以点这里重新开始新手引导，继续你的创作吧。',
          tutorials: '教程专区',
          generte_title: '生成器',
          prompt_placeholder: '描述你脑海中的画面',
          prompt_neg_prest: '预设',
          menu_label_preset: '预设',
          menu_label_favorite: '收藏',
          menu_label_history: '最近使用',
          menu_label_hot: '热门精选',
          prompt_negative_placeholder: '描述不想出现在画面里的内容',
          style_title: '风格',
          model_title: '模型',
          model_title_checkpoint: '基础模型',
          model_title_lora: '增强模型',
          model_window_title_checkpoint: '基础模型',
          model_window_title_lora: '增强模型',
          model_addlora: '添加风格滤镜/角色/元素加强模型',
          model_added_tip: '模型已添加',
          model_favorite_empty: '你还没有收藏模型',
          model_search_placeholder: '搜索寻找模型',
          model_search_favorites_only: '仅查看我的收藏',
          model_search_result_count: '{{count}}个模型',
          model_base_type_unmatch_tip: '该类型不适配已选中Checkpoint',
          model_base_type_unmatch_card_tip: '当前LoRA与Checkpoint 不可搭配使用',
          model_sort_option_common: '综合',
          model_sort_option_new: '最新',
          model_sort_option_hot: '最热',
          model_sort_option_most_used: '最常使用',
          model_sort_option_fav: '最近收藏',

          model_sd15: 'SD 1.5',
          model_sd15_short: '1.5',
          model_sd21: 'SD2.1',
          model_sdxl: '经典模型XL',
          model_sdxl_short: 'XL',
          model_sd35: 'SD 3.5',
          model_sd35_short: 'SD3.5',
          model_sd35M: '3.5M',
          model_sd35M_short: '3.5M',
          model_flux: '旗舰模型F.1',
          model_flux_short: 'F.1',
          model_sd30: 'SD3',
          model_pony: 'Pony',
          model_pixart_e: 'PixArt',
          model_hunyuan_11: 'HY1.1',
          model_hunyuan_12: 'HY1.2',
          model_kolors: 'Kolors',
          model_others: '其他版本',

          imgref_title: '图片参考',
          imgref_inpaint_title: '构图控制增强',
          imgref_prompt: '反推提示词',
          imgref_similarity: '相似度',
          imgref_composition: 'Control-net',
          addon_title: '脸部/手部修复',
          addon_choose: '选择一个插件',
          addon_fixface: '修复脸部',
          addon_fixhand: '修复手部',
          addon_settings: '插件设置',
          addon_settings_mergemode: '蒙版合并模式',
          addon_settings_maskedge: '蒙版缩小/扩大',
          addon_settings_mergemode_none: '独立',
          addon_settings_mergemode_merge: '合并',
          addon_settings_mergemode_mt: '合并并反转',
          setting_imgnum: '生图数量',
          generate_button: '生图',
          generate_button_no_prompt: '请输入提示词',
          parameter_title: '参数',
          parameter_samplerMethod: '采样器',
          parameter_samplingSteps: '采样步数',
          parameter_seedNumber: '种子',
          parameter_drawing: '绘图参数',
          parameter_steps: '采样步数',
          parameter_seeds: '随机种子',
          parameter_sampler: '采样器',
          parameter_scheduler: '调度器',
          parameter_vae: 'VAE',
          parameter_prompt: '提示词关联度',
          parameter_cfg: 'CFG Scale',
          parameter_clip: 'Clip Skip',
          parameter_vae_auto: '自动',

          inpaint_original_disabled: '暂时不支持用原模型进行局部重绘',
          reset_generate_params: '恢复默认设置',
          advanced_mode: '高级模式',

          imagetool_remix_button: '衍生',
          imagetool_remix_restore: '恢复原图设置',
          imagetool_changestyle_button: '风格转换',
          smartremove_fail_toast_title: '智能擦除失败',
          smartremove_success: '智能擦除成功',
          smartremove_fail_toast_content: '请稍后再试',

          imagetool_outpaint: '智能扩图',
          imagetool_outpaint_size: '扩图尺寸',
          imagetool_outpaint_original_size: '原始尺寸',
          imagetool_outpaint_new_size: '调整后尺寸',
          imagetool_outpaint_model_limit: '暂时不支持使用SDXL的风格/模型，请使用SD 1.5 的风格和模型',
          imagetool_outpaint_size_maxlimit: '只有小于1536 x 1536的图片可以进行扩图',
          imagetool_outpaint_size_minlimit: '只有大于512 x 512的图片可以进行扩图',
          imagetool_outpaint_exetends_minlimit: '请至少扩图8像素以上',
          imagetool_outpaint_size_adjust: '请先调整扩图区域或设置扩图尺寸',

          imagetool_changeFace: '换脸',
          imagetool_change_face: '换脸',
          imagetool_upload_image: '请上传人脸图片',
          imagetool_colorAdjustment: '调整色彩',

          img_bottom_tool_inpaint: '调整选区',
          img_bottom_tool_outpaint: '调整扩图区域',
          img_bottom_tool_collage: '拼贴位置',
          img_bottom_tool_original_image: '原图',
          img_bottom_tool_send_to_canvas: '保留这张图',
          img_bottom_tool_view_diff: '对比',

          selection_padding_title: '边缘',
          selection_padding_tooltips: '选区边缘',
          selection_feather_title: '羽化',
          selection_feather_tooltips: '羽化像素',
          selection_noninvert: '重绘选区区域',
          selection_invert: '重绘非选区区域',
          inpaint_maskinverted: '已重绘非选区',
          selection_eraser_size_title: '橡皮尺寸',
          selection_brush_size_title: '画笔尺寸',

          inpaint_style_common: '通用',
          inpaint_style_realistic: '真实',
          inpaint_style_photography: '人像摄影',
          inpaint_style_anime: '二次元',
          inpaint_style_illustration: '艺术插画',
          inpaint_style_3d: '3D立体',
          inpaint_style_cg: '游戏CG',
          inpaint_style_custom: '通用',
          inpaint_style_original: '原图风格',

          imgref_settings: '参考图设置',
          cn_options_title: '图片参考',
          cn_basetype_unsupported_tip: '使用（{{type}}）的时候暂时不支持该功能',
          cn_flux_count_limit_tip: '当前基础模型仅支持1张图片参考',
          cn_basetype_unsupported_types: '其他参考维度',
          imgref_dimension: '参考维度',
          imgref_dimension_in_use: '已添加过该参考维度',
          imgref_dimension_conflict_with_img2img: '图生图和主体参考不可同时使用',
          cn_method: '参考方法',
          cn_weight: '参考程度',
          un_support_dimens_tips: '更换（{{key}}）的基础模型后可使用',
          cn_control_weight: '权重',
          cn_control_start_step: '起始步数',
          cn_control_end_step: '完结步数',
          imgref_upload: '选择参考图',
          imgref_showoriginal: '展示原图',

          image_share: '分享',
          img_link_copied: '图片链接已复制',

          parameter_seeds_random: '随机',
          parameter_seeds_fixed: '固定',
          style_title: '风格',
          feed_recommendfeed: '为你推荐',
          style_selectedtag: '精选',
          style_sample: '更多例图',
          style_using: '使用中',
          style_use: '使用',
          common_fav: '收藏',
          style_resource: '使用的模型',
          style_editor_choice: '编辑精选',
          model_professionalmode: '专业模式开关',
          model_modelinfo: '详情',
          model_related_images_more: '灵感例图',
          model_unfav_toast: '取消收藏',
          model_fav_toast: '已收藏',
          model_modelinfo_title: '模型详情',
          model_base: '基础模型',
          model_run_count: '运行次数',
          parameter_vae: 'VAE',
          model_vae_universal: '通用',
          model_recommendckp: '推荐模型搭配',
          model_recommendlora: '推荐LoRA搭配',
          model_trigger: '触发词',
          model_related_images: '模型返图{{count}}张',
          view_all_model_related_images: '查看\n全部',
          model_search_keywords_suggest: '猜你想搜',
          model_intro: '简介',
          model_filter_base: '基础类型筛选',
          model_filter_all: '全部模型',
          model_checkpoint: 'Checkpoint',
          model_lora: 'LoRA',
          model_lora_limitetoast: '最多支持添加5个lora',
          model_lora_unavailable_toast: '与（{{name}}）不可搭配使用',
          model_default: '默认模型',
          imagetool_tilte: '图片工具',
          imagetool_remix: '画同款',
          imagetool_inpaint: '局部重绘',
          imagetool_inpaint_choose_style_tip: '请选择重绘风格',
          imagetool_inpaint_choose_area_tip: '请选择重绘区域',
          imagetool_collage_strength: '转换强度',
          selection_seg: '智能选区',
          selection_lasso: '套索工具',
          selection_marquee: '方框工具',
          selection_loading: '智能选区中',
          change_face_loading: '脸部识别中...',
          imagetool_inpainting: '局部重绘中',
          imagetool_changefacing: '换脸中',
          imagetool_outpainting: '智能扩图中',
          imagetool_upscaling: '高清放大中',
          imagetool_collaging: '拼贴重绘中',
          common_undo: '撤销',
          common_redo: '重做',
          selection_clear: '清空选区',
          imagetool_changestyle: '风格转换',
          magetool_changestyle_button: '风格转换',
          common_denoising_strength: '变化强度',
          model_new: '选择底膜',
          style_new: '选择风格',
          imagetool_upscale: '高清放大',
          imagetool_upscale_scale: '放大倍率',
          imagetool_upscale_size: '输出尺寸',
          imagetool_upscale_params: '放大参数',
          upscale_tile_type: '放大类型',
          upscale_tile_moredetail: '更多细节',
          upscale_tile_hdr: '原图超清',
          upscale_tile_weight: '细节丰富度',
          imagetool_upscale_strength: '变化幅度',
          imagetool_upscale_details: '细节丰富度',
          imagetool_upscale_hdr: '清晰度(HDR)',
          imagetool_upscale_similar: '相似度',
          imagetool_upscale_prompt: '提示词',
          upscale_method: '放大算法',
          upscale_td_method: '放大方法',
          upscale_strength: '重绘幅度',
          imagetool_collage: '拼贴重绘',
          common_denoising: '重绘幅度',
          gallary_title: '精选图库',
          feed_recommendfeed: '为你推荐',
          common_search: '搜索',
          common_search_result: 'n 个搜索结果',
          common_search_loading: '搜索中...',
          img_style_sent: '风格已添加到右侧菜单，请调整提示词',
          img_use_as_i2i_title: '用作图生图',
          img_use_as_i2i_desc: '添加到底部菜单，用作图生图',
          img_use_as_ref_title: '用作图片参考(Control-Net)',
          img_use_as_ref_desc: '添加到右侧菜单，用作图片参考',
          common_search_noresults: '未找到结果',
          feed_error: '数据异常，请重试',

          share_remix_creator_prefix: '使用',
          share_remix_creator_suffix: '生成',
          share_remix_simple_mode: '入门模式',
          share_remix_custom_mode: '自定义模式',
          share_remix_time_format: 'YY/MM/DD HH:mm',
          share_remix_button: '发送全部设置到生成器',
          share_remix_replace_button: '替换',
          share_remix_replace_ok_button: '知道了',
          share_remix_params_imported: '生成同款图片',
          share_remix_params_imported_tip: '已填入所有参数，生成同款图片吧',

          share_remix_img_replace: '替换想要{{title}}的图片',
          share_remix_img_replace_tip: '上传图片后，将自动填入生图设置',
          share_remix_ref_replace: '更换自己的图片',
          share_remix_ref_replace_tip: '用自己的图片作为参考生成同款',

          style_lora_title: '使用风格',

          common_layer_front: '移动到上层',
          common_layer_back: '移动到下层',
          common_download: '下载',
          common_share: '分享',
          common_group: '创建编组',
          common_merge: '合并图层',
          common_zoom_in: '放大',
          common_zoom_out: '缩小',
          common_zoom_fit: '显示画布所有图片',
          common_logout: '退出登陆',
          common_Guidance: '新手引导',
          imagetool_removeBackground: '智能去背景',
          imagetool_selectAreaTool: '抠图',
          remove_simple: '普通擦除',
          imagetool_smartRemove: '智能擦除',
          remove_button: '擦除',
          remove_button_loading: '擦除中',
          extract_button: '提取',
          extract_button_loading: '提取中',
          generator_pending: '准备中',
          generator_start: '生图任务启动中，请稍候...',
          prompt_neg_title: '负向提示词',

          imagetool_upscale_upperlimit: '最大可放大到5120 x 5120',
          imagetool_upscale_minimum: '高清放大仅支持最小256 x 256的图片',
          imagetool_extractpara: '反推生图参数',
          imagetool_extractpara_loading: '反推中...',
          imagetool_param_extracting: '生成信息反推中...',
          imagetool_param_rextract: '重新反推',
          imagetool_param_size: '图片大小',

          controlnet_fail_toast_title: 'Controlnet预处理失败',
          controlnet_fail_toast_content: '请在control-net模块点击重试',

          common_use: '使用',
          model_use: '使用模型',
          model_use_short: '使用模型',
          model_unuse: '取消使用',
          style_default: '默认风格',

          common_collect: '收藏',
          common_download: '下载',
          common_delete: '删除',
          history_exitselection: '退出多选',
          history_selected: '张图片已被选中',
          history_selectall: '全选',
          history_unselectall: '取消全选',
          common_uncollect: '取消收藏',
          imgref_composition: 'Control-net',
          history_allimageref: '导入图片参考参数',

          shortcut_title: '操作快捷键',
          shortcut_zoom_title: '放大/缩小画布',
          shortcut_pan_title: '移动画布',
          shortcut_other_title: '其他操作',
          shortcut_hold: '按住',
          shortcut_scrollmoues: '滚动滚轮',
          shortcut_drag: '拖动',
          shortcut_drag_2: '拖动鼠标',
          shortcut_keyboard: '键盘',
          shortcut_trackpad: '触控板',
          shortcut_mouse: '鼠标',
          shortcut_remove: '移除图片',
          shortcut_undo: '撤销',
          shortcut_redo: '重做',
          shortcut_locate: '定位',
          clean_title: '建议清理画布图片',
          clean_content1: '画布上有',
          clean_content2: '张图片，可能导致卡顿；',
          clean_content3: '清理后你仍可在',
          clean_content4: '中找到',
          clean_button: '清空画布图片',
          clean_doublecheck_title: '确定要清空画布上的所有图片吗？',
          clean_doublecheck_content: '清空画布后，你仍可以在历史记录中找到生成的图片',

          // 以上内容是2024年02月22日新增

          translate: '翻译',
          key: '你好',
          'global.server.error': '服务器错误',
          common_more_actions: '更多操作',
          history_album_selected: '精选专辑',
          page_load_error: '页面加载失败',
          try_again: '请重试',
          tool_move: '选择',
          tool_rectangle: '矩形(R)',
          tool_ellipse: '椭圆(O)',
          tool_triangle: '三角形',
          tool_hand: '平移画布',
          tool_upload: '上传图片(N)',
          canvas_zoomin: '放大',
          canvas_zoomout: '缩小',
          canvas_zoomreset: '重置',
          canvas_locate_generator: '定位到生成器',
          locate: '定位',
          color: '颜色',
          background_color: '背景颜色',
          user_login: '登录',
          user_logout: '退出登录',
          clear_forzen_task: '清除异常任务',
          generator: '生图画布',
          layer: '图层',
          image: '图片',
          inpaint: '局部重绘',
          inpaint_limit: '最多可同时创建{{n}}个局部重绘',
          upscale_max_tips: '最大不超过{{value}}',
          page: '页面',
          group: '创建编组',
          flattenImage: '合并图片',
          mixed: '混合选区',
          selection: '选区',
          create_selection_area: '创建选区',
          gallery: '灵感',
          style: '风格',
          rect: '矩形',
          ellipse: '椭圆',
          triangle: '三角形',
          details: '详细信息',
          style_suggestion: '基于提示词推荐风格',
          prompt_suggestion: '扩写建议',
          generate: '生成',
          prompt: '提示词',
          prompt_negative: '负向提示词',
          prompt_negative_placeholder: '描述你不想出现在画面里的内容',
          prompt_negative_standard: '通用',
          prompt_negative_Anime: '二次元',
          prompt_negative_hands: '崩手',
          prompt_negative_style: '画风',
          upscale_style_1: '真实人像',
          prompt_suggestion_title: '扩写推荐',
          style_search_placeholder: '输入关键词搜索风格',
          cancel: '取消',
          confirm: '确定',
          history: '历史记录',
          more: '更多',
          clearall: '清空',
          done: '完成',
          apply: '应用',
          match_style: '匹配风格',
          match_model: '匹配模型',
          match_reference: '参考图',
          style_history: '最近使用',
          style_use: '应用',
          style_disable: '停用',
          search_suffix: '个结果',
          search_suffix2: '个结果',
          style_using: '使用中',
          style_suggestion_title: '相似风格推荐',
          style_info_model: '引用模型',
          style_info_parameter: '参数信息',
          suggestion_base_model_title: '推荐搭配基础模型',
          newly_favorited_appy_tip: '刚刚添加了收藏模型，可快速使用',
          parameter_sampling_steps: '绘算法',
          follower: '粉丝数量',
          style_suggestion_noresults: '没有找到匹配的风格',
          style_history_noresults: '没有找到匹配的风格',
          gallery_noresults: '没有找到灵感数据',
          gallery_match_models: '提取模型组合',
          gallery_send_to_canvas: '发送到画布',
          gallery_generation_info: '详情',
          style_suggestion_false: '匹配风格失败，请重试',
          style_suggestion_bottom: '到底了/无更多内容了',
          Styles_for_you_based_on_your_prompt: '基于你的prompt推荐',
          For_You: '为你推荐',
          preparing_for_you: '准备推荐结果中',
          generator_size: '图片尺寸',
          generator_size_custom: '自定义',
          generator_parameter: '参数设置',
          generator_highres: '高分辨率',
          generator_imgnum: '生图数量',
          generator_allparameter: '高级参数',
          generator_locate: '定位到生图画布',
          network_error: '网络错误',
          controlnet_preprocess_network_error: '网络错误',
          generation_info: '生成信息',
          canvasimg_outside: '外部图片',
          characteristcs_title: '特征参考',
          characteristcs_applysize: '应用尺寸到生成画布',
          uploading: '上传中...',
          upload_tip: '点击或者拖放图片至此',
          fresh_upload_tip: '上传参考图',
          replace: '替换',
          duplicate: '创建副本',
          reference: '参考图',
          ImageReference: '设置参考图',
          lock_ratio: '固定比例',
          menu_restore_original_image: '还原到原图',
          menu_group: '创建组',
          menu_apply_reference: '作为参考图',
          menu_save_to_canvas: '保存到画布',
          menu_ungroup: '解除编组',
          menu_locate: '定位',
          menu_download: '下载',
          menu_copy: '复制',
          menu_image_send_params: '发送生成参数到生成器',
          menu_merge: '合并为图片',
          menu_delete: '删除',
          menu_bring_front: '移动至顶层',
          menu_send_back: '移动至底层',
          menu_clear_generation: '清除生成结果',
          characteristcs_preset_title: '参考模式',
          characteristcs_preset1: '大致参考',
          characteristcs_preset2: '精确参考',
          characteristcs_allsettings: '高级设置',
          characteristcs_generalscale: '整体参考幅度',
          characteristc: '提取特征',
          characteristcs: '提取特征',
          imgref_characteristcs_preference: '参考模式',
          cn_control_mode_1: '更注重提示词',
          cn_control_mode_2: '平衡',
          cn_control_mode_3: '更注重参考图',
          apply_reference_size: '应用尺寸到画布',
          image_author: '作者',
          send_to_generator: '发送到生成器',
          generate_prams_sent_tip: '已发送',

          cn_resize_mode: '缩放模式',
          cn_resize_mode_stretch: '拉伸',
          cn_resize_mode_crop: '裁剪',
          cn_resize_mode_fill: '填充',
          cn_model: '模型',

          cn_face: '人物长相',
          cn_face_img1: '长相参考',
          cn_face_img2: '脸部姿态 & 景别',
          cn_face_ref_preset: '预设',
          cn_face_ref_same: '使用长相参考图',
          cn_face_ref_custom: '自定义',
          cn_face_ref_front: '正脸',
          cn_face_ref_right: '右侧脸',
          cn_face_ref_left: '左侧脸',
          cn_face_ref_halfbody: '半身',
          cn_face_ref_fullbody: '中全景',
          cn_face_ref_portrait: '大头照',

          cn_face_img2_send: '发送到图生图',
          cn_face_img1_tips: '正脸、无遮挡',
          cn_face_upload_image: '上传图片',

          cn_face_title: '人脸图片',

          cn_all_params: '全部设置',
          cn_source_referece_only_tip: '仅可使用选中图作为参考图',
          cn_preprocessor: '预处理器',
          cn_pixel_perfect: '完美像素',
          cn_pixel_perfect_on: '打开',
          cn_pixel_perfect_off: '关闭',
          cn_preprocessor_resolution: '分辨率',
          cn_disabled_for_current_model: '该功能无法搭配当前模型使用',
          loading: '加载中',
          paremeter: '基础参数',
          parameter_seeds_random: '随机',
          parameter_seeds_fixed: '固定',
          parameter_seeds_placeholder: '请输入随机种子',
          merge: '合并图层',
          segmantanything: '智能选区',
          original: '原图',
          originalimage: '原图',
          inpaint_scale: '重绘幅度',
          image_merge_error: '合并图层失败',
          image_merge_success: '合并图层成功',
          image_merge_result_too_large: '合并后的图片尺寸过大',
          image_segment_error: '智能分区失败，请稍后重试',
          image_segment_error_sub: '该图片处理失败，可尝试处理其他图片或稍后重试',
          image_segment_success: '智能选区识别成功',
          image_segment_empty: '智能选区结果为空',
          image_crop_error: '裁剪失败',
          image_crop_success: '裁剪成功',
          image_cropping: '图片裁剪中',
          image_merging: '图片合并中',
          image_cutting: '背景去除中',
          image_cutout_error: '背景去除失败',
          image_cutout_error_sub: '该图片处理失败，可尝试处理其他图片或稍后重试',
          image_cutout_success: '背景去除成功',
          image_cutout_tip: '一键抠图',
          imagetool_crop: '裁剪',
          image_segment_tip: '自动识别选区',
          image_lasso_tip: '套索工具',
          image_rect_tip: '框选工具',
          image_tool_exit: '退出',
          image_tool_new_image: '新图',
          image_tool_new_image_upload: '上传图片',
          image_tool_new_image_uploading: '正在上传',
          image_tool_unselect_tip: '上传图片或选择生成图片可使用',
          image_tool_collage_unselect_tip: '选中画布上至少两张以上图片进行',
          image_tool_select_button: '选择画布图片',
          image_tool_reference: '图片参考',

          image_publish_entry_btn: '发布到Liblib',
          image_publish_title: '分享你的图片和其生成信息',
          image_publish_img_title: '图片标题',
          image_publish_img_tags: '图片标签',
          image_publish_img_desc: '图片描述',
          image_publish_success: '发布成功',
          image_publish_fail: '发布失败',
          image_publish_btn: '发布',

          image_extract_success: '提取成功',
          image_extract_fail: '提取失败',

          image_tool_adjust: '调整',
          image_tool_vary_overall: '整体微调',
          image_tool_vary_overall_tip: '对图像整体进行调整',
          image_tool_vary_details: '细节微调',
          image_tool_vary_details_tip: '对图像细节进行调整',

          image_tool_use: '使用',
          image_tool_use_style: '风格',
          image_tool_use_style_tip: '基于图像生成相关风格的图片',
          image_tool_use_style_disabled_tip: '暂不支持上传的图片',
          image_tool_use_lora: '增强模型',
          image_tool_use_lora_disabled_tip: '当前图片未使用增强模型',
          image_tool_use_prompt: '提示词',
          image_tool_use_image: '图片',

          image_info_weight: '权重 ',
          image_info_reproduce: '重新编辑',
          image_info_reproduce_inpaint: '重新编辑',

          workflow_image_upload: '上传图片',
          workflow_video_upload: '上传视频',
          workflow_video_replace: '替换视频',
          workflow_video_play: '播放视频',
          workflow_model_loading: '模型加载中',
          workflow_model_pick: '选择模型',
          workflow_mask_source_image_tip: '上传图片后可绘制蒙版',
          workflow_mask_draw_button: '绘制蒙版',
          workflow_image_segmenting: '自动分割中',

          inpaint_discard: '放弃',
          controlnet_reload: '重试',
          controlnet_preprocess_error: '提取构图特征失败',
          controlnet_preprocess_error_sub: '如需提取构图特征，可在构图参考模块点击重试',
          error_controlnet_image_loading: '请等待构图特征提取完成',
          generator_failed: '生图失败',
          generator_success: '生图成功',
          generator_queue: '正在排队中...第{{n}}位',
          generator_failed_2: '生图失败,',
          generator_regenerate: '重新生图',
          generator_rerun: '重新运行',
          generator_exitrun: '退出运行',
          generator_task_waiting: '等待中',
          generator_task_queuing: '排队中',
          generator_loading: '正在加载资源，请稍候...',
          generator_ing: '正在生图中，请稍候...{{n}}%',
          generator_limit: '每次只能处理3个任务，请等待当前任务完成',
          history_entrance: '历史记录',
          history_tab1: '全部',
          flow_empty_tip1: '还没有使用过工作流',
          flow_empty_tip2: '最近使用',
          history_tab2: '专辑',
          search_clear: '取消',
          history_search_placeholder: '搜索',
          history_search_placeholder_gallery: '搜索寻找灵感',
          history_searching: '加载中',
          history_rank_up: '按修改时间升序',
          history_rank_down: '按修改时间降序',
          storage: '已用空间',
          history_limit: '图片',
          history_useup1: '空间即将用尽',
          history_useup2: '为了不影响您的正常使用，建议提前清除不需要的图片以释放存储空间。',
          history_morestorage: '扩容',
          collect: '收藏',
          download: '下载',
          delete: '删除',
          copy_image: '复制图片',
          history_regenerate: '一键导入全部参数',
          history_ref: '设为参考图',
          history_movetocanva: '添加到画布',
          model_fetch_error: '获取模型信息失败',
          copy_prompt: '复制提示词',
          prompt_fetch_error: '获取提示词失败',
          prompt_fetch_empty: '未获取到有效内容',
          prompt_copy_toast: '提示词已复制',
          history_deletecheck_main: '确认删除所选的n张图片？',
          history_deletesingleimage: '确认删除所选图片吗？',
          history_deletecheck_sub: '图片删除后无法恢复',
          history_bottom: '到底了',
          history_album_add: '添加到我的专辑',
          history_album_new: '新建专辑',
          history_album_ungrouped: '未分组',
          history_album_imgcoount: 'n 张',
          history_album_change: '更改专辑',
          rename: '修改专辑名称',
          history_album_deletecheck_main: '确认删除专辑“插画概念稿”吗？',
          history_album_deletecheck_sub: '同时删除该专辑内的图片',
          history_album_delallcheck_main: '确认删除“未分组”下的全部图片吗？',
          history_album_placeholder: '该专辑下还没有收录的图片',
          history_album_defualtname: '新专辑',
          create: '创建',
          history_image_info: '图片信息',
          history_usemodel: '引用模型',
          model: '模型',
          professionalMode: '专业模式',
          allsettings: '高级配置',
          copy: '复制',
          collapse: '收起',
          expand: '展开',
          img_scale: '图片尺寸',
          parameter_seed: '随机种子',
          parameter_applyall: '一键导入全部参数',
          nsfw: 'NSFW 内容',
          nsfw_view: '查看',
          illigal_content: '已屏蔽不合法的内容',
          share: '分享链接',
          copied: '已复制',
          collect_toast: '图片已收藏到',
          history_album_addtoast: '已加入',
          collect_cancel_toast: '已取消收藏',
          history_album_delete_toast: '专辑已删除',
          history_ref_toast: '已设置为参考图',
          history_apply_toast: '已导入全部参数',
          copy_prompt_toast: '已复制提示词',
          copy_image_toast: '已复制图片',
          copy_image_error: '复制图片失败',
          copy_negprompt_toast: '已复制负向提示词',
          delete_img_toast: '图片已删除',
          delete_imgs_toast: '已删除 n 张图片',
          download_limit_toast: '单次最多可下载x张图片',
          style_use_toast: '已应用所选风格',
          style_pulloff_toast: '该风格已被原作者下架，暂时无法使用，请应用其他风格',
          parameters_import_failed: '该图片已删除，无法导入参数信息',
          share_success_toast: '分享链接已复制',
          upload_fail_toast: '图片上传失败，请重试',
          upload_all_fail_toast: '全部上传失败，请重试',
          upload_completed_toast: '图片上传完成，其中{{errorCount}}张图片上传失败',
          upload_success_toast: '图片上传成功',
          internet_loading_toast: '网络环境差，资源加载缓慢，请稍后',
          internet_suggestion_toast: '网络环境差，建议前往更优质的网络环境',
          internet_fail_toast: '网络连接失败，请检查网络',
          internet_back_toast: '网络连接已恢复',
          generator_timeout_toast: '生图任务已超时，请重新尝试',
          model_pulloffissue_toast: '资源加载异常，建议尝试更换为其他风格',
          img_format_toast: '文件格式有误，请上传png、jpeg或jpg格式的图片',
          img_size_toast: '图片尺寸过大，请上传不超过20MB的图片',
          img_resolution_toast: '图片分辨率过大，建议上传不超过2048*2048的图片',
          inpaint_resolution_toast: '图像分辨率过大，请调整图像尺寸至2048*2048以下',
          img_resize_toast: '已自动缩放图片至合适尺寸',
          generator_resize_toast: '已自动缩放生图画布至合适尺寸',
          inpaint_size_too_large: '图像分辨率过大，请调整图像尺寸至2048*2048以下',
          generator_multitast_toast: '您当前有图像正在生成，请在完成后再发起下一次生图任务',
          user_feedback_toast: '请描述遇到的问题，稍后我们会通过邮箱联系您',
          user_inputemail: '请输入您的邮箱',
          generator_nostyle_toast: '选择风格后才可以生成图片',
          generator_queue_overtime: '排队超时，请稍后重试',
          generator_fail_toast: '生图失败，请稍后重试',
          history_storagefull: '空间用尽',
          history_storagefullalert: '为了不影响您的正常使用，建议清除不需要的图片以释放存储空间。',
          history_storagefull_tip: '空间已满，请前往「生图历史」删除不需要的图片以释放存储空间',
          comfirm: '确定',
          no_search_result_all: '全部历史搜索无结果',
          no_search_result_album: '专辑页搜索无结果',
          no_history_record: '全部历史没有生成记录',

          imgref_noselece: '选择模式',
          imgref_limit: '你最多可以添加{{value}}个图片参考',

          img_no_switch_tip_title: '不建议替换图片',
          img_no_switch_tip_message: '已有图生图设置，为了保证生图效果，建议使用相同图片做为图片参考',

          illigal_content_text: '图片包含敏感内容，请调整参数重试',
          toolbar_disabletooltips_oneimage: '上传图片或选中生成的图片可使用',
          toolbar_disabletooltips_twiimage: '选中画布上至少2张以上的图片可使用',
          simple_tip_text: '仅自定义模式下可使用',
          pro_mode_opentip: '打开自定义模式可使用该模型',
          setting_text: '设置',
          prompt_setting_autofill: '自动补全',
          recommend_expand: '扩写推荐',
          two_language: '双语对照',
          prompt_setting_enhance: '提示词修饰',
          prompt_setting_title: '提示词设置',
          guidance_switch_button: '开启',
          guidance_custommodel_title: '自定义模型组合',
          guidance_custommodel_content: '开启自定义模式，更多模型选择。',
          guidance_imgref_title: '更多参考维度/自定义参数',
          guidance_imgref_content: '开启自定义模式，更多参考图设置。',
          simeplemode_base_tool_tip: '开启自定义模式，匹配模型组合',
          simplemode_landing_step1: '你使用Pic Pic的主要场景是：',
          simplemode_landing_case1: '视觉设计',
          simplemode_landing_case2: '游戏/动漫设计',
          simplemode_landing_case3: '摄影',
          simplemode_landing_case4: '建筑/空间设计',
          simplemode_landing_case5: '插画',
          simplemode_landing_case6: 'AI爱好者',
          simplemode_landing_step2: '选择使用模式',
          simplemode_simplemode: '入门模式',
          simplemode_simplemode_info: '适合AI绘画新手',
          simplemode_custommode: '自定义模式',
          simplemode_custommode_info: '适合用过SD的专业玩家',
          common_last: '上一步',
          common_next: '下一步',
          simplemode_landing_endbutton: '开始创作',
          prompt_placeholder_recreate: '描述想要重新绘制的内容,不填将基于原图生成',
          simplemode_prompt_placeholder: '描述你想要的画面',
          prompt_suggestion_text: '扩写',
          toolbar_switch: '仅自定义模式下可使用',
          topbar_multiselect: '多张图片被选中，本功能仅支持单张图片',
          guidance_custommode_title: '自定义模式切换',
          guidance_custommode_content: '可在入门模型和自定义模式间切换。',
          guidance_got_button: '知道了',
          imgref_similarity_more: '更多参考维度/自定义参数',
          imgref_switchcus: '打开自定义模式，添加多张参考图',
          // add 096
          imgref_mode_tile: 'Tile分块',
          imgref_mode_referenceonly: '快速参考',
          imgref_mode_canny: '线稿轮廓',
          imgref_mode_MLSD: 'MLSD线稿',
          imgref_mode_lineart: 'Lineart线稿',
          imgref_mode_soft: 'Soft Edge线稿',
          imgref_mode_scribble: 'Scribble线稿',
          imgref_mode_depth: '景深',
          imgref_mode_seg: 'Segmant构图分割 ',
          imgref_mode_normal: '法线贴图 ',
          imgref_mode_openpose: '姿势',
          imgref_mode_color: '配色参考',
          imgref_mode_shuffle: '配色打乱',
          imgref_mode_recolor: '重新上色',
          imgref_mode_ip_adapter: '风格迁移',
          imgref_mode_entity_control: '主体',
          imgref_mode_brightness: '光影',
          use_model: '马上试用',
          simplemode_sd3_tag: '最新发布',
          simplemode_model_photo: '真实摄影',
          simplemode_model_art: '艺术插画',
          simplemode_model_3D: '3D立体',
          simplemode_model_CG: '游戏CG',
          simplemode_model_Anime: '二次元',
          simplemode_model_Architecture: '建筑设计',
          simplemode_model_base: '基础模型XL',
          simplemode_model_more: '自定义模型',
          // image bottom tool
          simplemode_style: '风格强化',
          simplemode_style_unavailiable: '该风格与当前模型搭配效果可能不稳定',
          common_sort1: '推荐',
          common_sort2: '最新',
          common_sort3: '最热',
          gallary_sample_more: '更多相关灵感',
          gallary_home: '回到首页',
          gallary_sample_title: '张例图',
          model_fromgallary: '模型组合',
          upscale_para_1: '变化幅度',
          upscale_para_2: '风格类型',
          upscale_style_2: '动漫风格',
          upscale_style_3: '游戏CG风格',
          upscale_style_4: '艺术插画风格',
          upscale_style_5: '3D渲染',
          feature_disabled_for_sd3: '暂时无法搭配当前基础模型使用',
          feature_disabled_for_sd3_2: '暂时无法搭配当前基础模型使用',
          character_custom_title: '概念强化模型推荐',
          character_beginner_title: '角色强化',
          share_image_title: '分享你的图片和其生成信息',
          share_image_content_prefix: '我生成了超赞的图片，',
          share_image_link_title: '复制链接',
          share_image_all_title: '复制全部',
          setting_size: '生图尺寸',
          original_setting_size: '原图尺寸',
          imgupload_placeholder: '上传图片参考/从画布发送图片',
          imgupload_placeholder_entity_control: '单个主体、清晰无遮挡',
          prompt_imgtoimg: '图生图',
          img2img_use_as_reference: '增加参考维度',
          img2img_disabled_flux1: '使用Flux.1的时候暂时不支持该功能',
          img_prompt: '转换成提示词',
          img_size: '同步生图尺寸',
          prompt_imgtoimg_tips: '上传图片进行图生图',
          prompt_setting_enhance_on: '智能扩写增强已开启',
          prompt_setting_enhance_off: '智能扩写增强已关闭',
          hires_original: '初始尺寸',
          hires_scale: '放大倍率',
          hires_algorithm: '放大算法',
          hires_step: '重绘步数',
          hires_finalimage: '最终生图尺寸',
          setting_hires: '高分辨率修复',
          imgref_similarity_original: '更像原图',
          imgref_similarity_creative: '更创意',
          imgref_similarity_cus: '自定义',
          canvas_rate: '评价',
          rate_thanks: '感谢您的反馈',
          rate_title: '反馈',
          common_cancel: '取消',
          common_submit: '提交',
          rate_op1: '不符合提示词描述',
          rate_op2: '不是我想要的风格',
          rate_op3: '生成时间久',
          rate_op4: '图片质量差',
          rate_op5: '图片艺术感不足',
          rate_op6: '其他',
          rate_describe: '描述你的问题（可选）',
          rate_question: '您对生成的图片不满意的地方是? (必填)',
          prompt_weight: '权重',
          imgref_advancetips_title: '右下角打开高级设置后可使用',
          imgref_advancetips_content: '打开后可设置Control-net所有参数',
          basemodel_preset: '预设模型',
          basemodel_all: '全部基础模型',
          basemodel_toshakker1: '还没有收藏基础模型，快去 ',
          basemodel_toshakker2: '浏览并收藏喜欢的模型吧',
          basemodel_toshakker3: '模型广场',
          style_history_new: '最近使用',
          lora_details_presetpara: '使用推荐参数',
          models_favorites: '收藏',
          imagetool_inpiant_style: '重绘风格',
          lora_recommend: '概念强化模型(LoRA)推荐',
          model_used_short: '已添加',
          model_promptbase: 'Prompt相关推荐',
          common_sort4: '全部类型',
          model_nohistory: '暂无使用记录',
          model_nosearch: '暂无搜索结果',
          model_nofav: '暂未收藏模型，去全部模型中添加吧！',
          model_search: '搜索结果',
          model_search_text: '搜索',
          model_result_no_more: '没有更多了',
          model_search_selected: '已选类型',
          basemodel_largest_match: '基础模型最多搭配',
          model_online_unsupported: '暂不支持在线使用',
          model_recently_favorite: '最近收藏',

          image_card_info: '生成信息',
          gallery_title: '图片案例',
          gallery_no_more: '没有更多了',
          model_gallery_title: '模型例图',
          model_gallery_tab_cases: '作者示例',
          Modelgallery_title_Example: '示例图',
          Modelgallery_title_Gallery: '更多返图',
          imakgegallery_title_rec: '推荐',
          Modelgallery_title_top: '热门',
          model_gallery_tab_more: '热门图片',
          model_gallery_btn: '例图',
          model_gallery_latest_version: '最新版本',
          model_gallery_version_all: '全部版本',

          imgref_repreview: '重新生成',
          imgref_preview: '参考图预览',
          lora_details_title: '增强模型详情',
          lora_details_title2: '推荐搭配基础模型',
          prompt_tip_text: '输入提示词，生成精美画面',
          prompt_tip_content: '只需输入简单提示词，我们将为你扩写出超出片的提示词',
          tip_change_browser_1: '当前浏览器存在兼容问题将影响您的正常使用，建议更换',
          tip_change_browser_2: 'Chrome浏览器访问',
          tip_update_browser_version_text: '当前浏览器版本较低，请升级到最新版本',
          guideTip_prompt_title: '输入提示词开始创作',
          guideTip_prompt_desc: '输入风格、画面主体等提示词来创作精美图片，输入完成后，点击“生成”来创作图片。',
          guideTip_checkpoint_title: '基础模型',
          guideTip_checkpoint_desc:
            '使用星流通用大模型可画出任意你想象的画面，百种风格包括不限于写实摄影、插画、动漫、3D立体等。',
          guideTip_lora_title: '增强模型',
          guideTip_lora_desc: '使用增强模型来创作特定风格、角色、元素和主体',
          guideTip_img2img_title: '图生图',
          guideTip_img2img_desc: '使用图生图，参照图片的整体风格和内容进行创作',
          guideTip_imgreferrer_title: '图片参考',
          guideTip_mode_desc:
            'SD资深玩家？打开高级模式，可以自由选择上万个Checkpoint / LoRA模型、自定义生图参数、使用全部Control-net、设置高分辨率修复、ADetailer等SD功能。',
          guideTip_mode_title: '高级模式',
          guideTip_imgreferrer_desc: '使用图片参考来实现：人物长相参考、景深、线稿、姿势等维度的参考',
          guideTip_finish_title: '快速导览',
          guideTip_finish_desc_1: '你可以点击',
          guideTip_finish_desc_2: '随时查看导览',
          prompt_guide_topic: '试试这些主题：',
          prompt_guide_switch: '换一换',
          prompt_guide_close_title: '关闭推荐主题词',
          prompt_guide_stop: '不再显示',
          prompt_guide_close_once: '单次关闭',
          history_title: '生图历史',
          history_bydateimg: '张图',
          tip_next: '下一步',
          tip_prev: '上一步',
          tip_done: '完成',
          load_more: '加载更多',
          set_neg_prompt_tip: '设置负向提示词',
          set_neg_prompt_disabled_tip: '仅选择SD1.5 时可用',
          add_text: '添加',
          prompt_weight_button: '加权重',
          prompt_weight_title: '增加提示词权重',
          prompt_improve_button: '提示词优化',
          prompt_delete_button: '删除所有提示词',
          prompt_weight_placeholder: '描述你想重点创作的内容',
          prompt_weight_title: '增加提示词权重',
          prompt_improved: '优化后提示词',
          public_tips_desc: '生成的图像将为您的私密资产，如果您希望自动分享至社区，请在历史记录中切换设置.',
          prompt_neg_setting_title: '负向提示词设置',
          modelhub_tab_featured: '推荐精选',
          modelhub_tab_more: '更多',
          public_setting: '图片公开',
          public_tips_title: '公开或私有图片',
          color_title: '颜色参考',
          upload_image_to_get_colors: '上传图片识别颜色',
          color_para_title1: '自定义颜色',
          color_para_title2: '预设颜色',
          randomize: '换一批',
          color_para_para1: '参考程度',
          color_upload_para1: '从图片中提取颜色',
          color_upload_para2: '上传图片参考',
          color_para_title3: '拾色器',
          color_canvas_para1: '用作颜色参考',
          color_canvas_para2: '添加到右侧菜单，用作颜色参考',
          color_upload_all: '全部使用',
          pen_size: '大小',
          common_finish: '完成',
          tool_r: '矩形',
          tool_o: '圆形',
          tool_P: '画笔',
          r_size: '自定义',
          img_to_text: '图转词',
          imgadjust_title: '调整色彩',
          imgadjust_sutitle1: 'AI色彩调整',
          imgadjust_upload: '导入图片进行AI追色',
          imgadjust_upbutton: '上传图片',
          imgadjust_sutitle2: '单一调整',
          imgadjust_para1: '色相',
          imgadjust_para2: '饱和度',
          imgadjust_para3: '亮度',
          imgadjust_para4: '对比度',
          imgadjust_para5: '透明度',
          tool_text: '文字',
          tool_t_placeholer: '请输入文本',
          flow_g_title: '生成器',
          flow_g_flow: '工作流',
          outpaint_over_size_tips: '使用该比例会导致长/宽大于2048,超出可扩图范围',
          flow_edit: '编辑中...',
          flow_runing: '自动运行中...',
          flow_g_op1: '重命名',
          flow_g_op2: '下载',
          flow_g_op3: '删除',
          flow_g_op4: '复制并新建',
          flow_g_op5: '运行',
          selection_auto: '自动选区',
          selection_text1: '主体',
          selection_text2: '人脸',
          selection_text3: '皮肤',
          selection_text4: '头发',
          selection_text5: '自定义',
          img_bottom_bar_edit: '进入编辑',
          img_bottom_bar_use: '使用',
          inpaint_edit_community: '去社区查看',
          comfy_loading: '正在加载工作流设置',
          speed_up: '会员加速',
          gprogress1: '图片生成中...',
          gprogress2: '局部重绘中...',
          gprogress4: '智能扩图中...',
          flow_g_apply: '快捷应用',
          flow_quick_apply: 'AI工具箱',
          flow_quick_apply_icon: 'AI工具',
          style_code: '风格种子',
          copy_success_message: '复制成功',
          copy_fail_message: '复制失败',
          press_esc_exit: '按Esc可退出',
          use_btn: '立即使用',
          use_btn1: '使用',
          back_projects: '返回项目库',
        },
      },
    },
  },
  function (err) {
    console.log(`initialized and ready to go!`, err);
  },
);

export const translate = (key, ...args) => {
  if (i18next.exists(key)) {
    return i18next.t(key, ...args);
  } else {
    return key;
  }
};

/**
 * 转换为特定的语言
 *
 * @param {*} lng en: 英文, zh: 汉语
 * @returns Promise
 */
export const changeLanguage = (lng) => {
  return i18next.changeLanguage(lng);
};

export const getCurrentLanguage = () => {
  return i18next.language;
};
